// src/ramda-adjunct/isNotUndefined.ts
function isNotUndefined(t) {
  return t !== void 0;
}
var isNotUndefined_default = isNotUndefined;

export {
  isNotUndefined_default
};
//# sourceMappingURL=chunk-ZNK2UXVC.mjs.map